import React from 'react';
import Modal2 from 'components/commons/modal/Modal2';

type Props = {
  hide: () => void;
  isShow: boolean;
};

export const GettingSbiAccountDataModal = ({
  hide,
  isShow,
}: Props): React.ReactElement => {
  return (
    <Modal2 isShow={isShow}>
      <div className="p-4 max-h-modal overflow-y-auto">
        <div className="flex flex-col text-bluegray-700">
          <div className="flex flex-row">
            <div className="font-bold text-lg">SBI証券の情報を取得中です</div>
            <div
              className="icon-close ml-auto text-gray-500 cursor-pointer"
              onClick={hide}
            />
          </div>
          <div className="mt-4 text-sm">
            SBI証券の入金情報は以下時間に更新されます。
          </div>
          <div className="mt-2 text-sm">・15:00~22:00</div>
          <div className="mt-4 text-sm">
            数日お待ち頂いても入金情報が更新されない場合はお問い合わせをお願いします。
          </div>
          <div className="mt-2 text-sm text-blue-700">
            <a
              href="https://support.minkabu.jp/hc/ja/requests/new?ticket_form_id=360002511233"
              target="_blank"
              rel="noopener noreferrer">
              お問い合わせ
            </a>
          </div>
          <button
            className="mt-6 p-2 justify-center w-full text-sm"
            onClick={hide}>
            閉じる
          </button>
        </div>
      </div>
    </Modal2>
  );
};
